import { db } from "@/shared/firbase";
import {
  collection,
  DocumentData,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled, { css } from "styled-components";
import flex from "@/utils/flex";
import Gold from "@/assets/gold.png";
import Silver from "@/assets/silver.png";
import Bronze from "@/assets/bronze.png";
import Loading from "../Loading";
import { useTranslation } from "react-i18next";
import { desktop, mobile, tablet } from "@/utils/responsive";
import Header from "@/components/Header/Index";

const Index = () => {
  const { name } = useParams();
  const dbCollection = query(
    collection(db, `${name}-rank`),
    orderBy("count", "desc")
  );
  const { t } = useTranslation();
  const [arr, setArr] = useState<DocumentData[]>([]);
  const [count, setCount] = useState<DocumentData[]>([]);
  const navigate = useNavigate();

  const getData = async () => {
    //  데이터베이스에서 가져오기
    const data = await getDocs(dbCollection);
    //  가져와서 배열에 집어넣기
    setArr(data.docs.map((doc) => doc.data()));
    setCount(data.docs.map((doc) => doc.data().count));
    return arr;
  };
  useEffect(() => {
    getData();
  }, []);

  const distinguishOrder = (v: DocumentData, i: number) => {
    let max = count[0];
    for (let i = 1; i < count.length; i++) {
      if (max < count[i]) max = count[i];
    }

    const secondArr = count.filter((v) => v !== max);
    let secondMax = secondArr[0];
    for (let i = 1; i < count.length; i++) {
      if (max < secondArr[i]) max = secondArr[i];
    }

    const thirdArr = secondArr.filter((v) => v !== secondMax);
    let thirdMax = thirdArr[0];
    for (let i = 1; i < thirdArr.length; i++) {
      if (max < thirdArr[i]) max = thirdArr[i];
    }

    switch (v.count) {
      case max:
        return (
          <div className="flexDiv" key={i}>
            <StMedal pic={Gold} />
            <StImage pic={v.url} />
            <div className="infoDiv">
              <div className="name">{t(v.name)}</div>
              <div>
                {t("우승")}: '{v.count}' {t("번")}
              </div>
            </div>
          </div>
        );
      case secondMax:
        return (
          <div className="flexDiv" key={i}>
            <StMedal pic={Silver} />
            <StImage pic={v.url} />
            <div className="infoDiv">
              <div className="name">{t(v.name)}</div>
              <div>
                {t("우승")}: '{v.count}' {t("번")}
              </div>
            </div>
          </div>
        );
      case thirdMax:
        return (
          <div className="flexDiv" key={i}>
            <StMedal pic={Bronze} />
            <StImage pic={v.url} />
            <div className="infoDiv">
              <div className="name">{t(v.name)}</div>
              <div>
                {t("우승")}: '{v.count}' {t("번")}
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="flexDiv" key={i}>
            <StImage pic={v.url} />
            <div className="infoDiv">
              <div>{t(v.name)}</div>
              <div>
                {t("우승")}: '{v.count}' {t("번")}
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <Header />
      <Wrap>
        {arr.length === 0 ? (
          <Loading />
        ) : (
          <div className="content">
            <div className="title">
              {t(`${name}`)} {t("이상형의 랭킹!")}
            </div>
            <button onClick={() => navigate("/")}>{t("다른 게임 하기")}</button>
            <div className="gridDiv">
              {arr.map((v, i) => distinguishOrder(v, i)).sort()}
            </div>
          </div>
        )}
      </Wrap>
    </>
  );
};

export default Index;

const Wrap = styled.div`
  ${flex({ direction: "column" })}

  height: 90vh;
  overflow-y: scroll;
  .content {
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .gridDiv {
    width: 95%;
    height: 100vh;
    display: grid;
    grid-template-columns: 22% 22% 22% 22%;
    grid-auto-rows: 20%;
    gap: 3rem;
    justify-content: center;
    // responsive
    ${mobile(css`
      grid-template-columns: 90%;
    `)}
    ${tablet(css`
      grid-template-columns: 45% 45%;
    `)}
  ${desktop(css`
      grid-template-columns: 22.5% 22.5% 22.5% 22.5%;
    `)}
  }

  p {
    font-size: 3rem;
  }
  .flexDiv {
    ${flex({ justify: "flex-start" })}
    position: relative;
    border: 5px solid black;
  }
  .infoDiv {
    ${flex({ direction: "column" })}
    width: 150px;
    margin-left: 1rem;
    .name {
      font-weight: 700;
    }
  }
  button {
    border: none;
    margin: 2rem;
    width: 200px;
    height: 100px;
    cursor: pointer;
    border-radius: 30px;
    :hover,
    :active {
      background-color: var(--sub);
    }
  }
  .title {
    font-size: 1.5rem;
    margin-top: 2rem;
  }

  // responsive
  ${mobile(css`
    font-size: 1.1rem;
    button {
      width: 200px;
      height: 70px;
    }
  `)}
  ${tablet(css`
    font-size: 2rem;
    button {
      width: 140px;
      height: 100px;
      margin: 1rem;
    }
  `)}
  ${desktop(css``)}
`;

const StImage = styled.div<{ pic: string }>`
  background-image: url(${(props) => props.pic});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 200px;
  height: 100%;
  border-right: 5px solid var(--black);
`;

const StMedal = styled.div<{ pic: string }>`
  background-image: url(${(props) => props.pic});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  top: -20%;
  right: -5%;
  width: 30px;
  height: 60px;
`;
